import { Injectable, Renderer2, inject } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class FontLoaderService {
    private renderer = inject(Renderer2);

    private fontElement: { [key: string]: any; } = {};

    loadFont(identifier: string, fontUrl: string): void {
        if (!this.fontElement[identifier]) {
            this.fontElement[identifier] = this.renderer.createElement('link');
            this.renderer.setAttribute(this.fontElement[identifier], 'rel', 'stylesheet');
            this.renderer.setAttribute(this.fontElement[identifier], 'href', fontUrl);
            this.renderer.appendChild(document.head, this.fontElement[identifier]);
        }
    }

    //method for removing font from header
    removeFont(identifier: string) {
        if (this.fontElement[identifier]) {
            this.renderer.removeChild(document.head, this.fontElement[identifier]);
            delete this.fontElement[identifier];
        }
    }

    //remove all fonts
    romoveAllFonts() {
        Object.keys(this.fontElement).forEach((key) => {
            if (this.fontElement[key]) {
                this.renderer.removeChild(document.head, this.fontElement[key]);
                delete this.fontElement[key];
            }
        })
    }
}